<template>
  <section>
    <div class="row header justify-content-between">
      <div class="col dates">{{sponsorshipItem.dates}}</div>
      <div class="col website">{{sponsorshipItem.siteUrl}}</div>
    </div>
    <img :src="getStaticPath('img/temp/' + sponsorshipItem.coverUrl)" />
    <div class="row">
      <div class="col-8">
        <div class="name">{{sponsorshipItem.name}}<br /><span class="location">{{sponsorshipItem.city}}, {{sponsorshipItem.country}}</span></div>
      </div>
    </div>
  </section>
</template>
<script>
  import UtilityMixin from '@/components/shared/mixins/UtilityMixin'

  export default {
    name: 'sidebar-sponsorship',
    mixins: [ UtilityMixin ],
    data () {
      return {
        sponsorshipItem: {
          dates: 'April 25-28, 2016',
          siteUrl: 'http://ivaoconf.com',
          coverUrl: 'SponsorshipCover.png',
          name: 'Biomedical Innovation in Healthy Longevity',
          city: 'Saint-Petersburg',
          country: 'Russia'
        }
      }
    }
  }
</script>
<style scoped lang="scss">
  section{
    margin: 38px 0;
    padding-bottom: 10px;
    border-bottom: 1px solid $grey-border;
    line-height: 1.2;
    .header {
      font-family: 'Open Sans';
      font-size: 14px;
      margin-bottom: 12px;
    .dates {
      color: $primary-color;
      font-weight: 600;
    }
    .website {
      color: $secondary-color;
      font-style: italic;
      text-align: end;
    }
    }
    .name {
      color: $primary-color;
      font-family: 'Merriweather';
      font-size: 20px;
      margin-top: 18px;
    }
    .location {
      font-size: 14px;
    }
    img {
      width: 100%
    }
  }
</style>



// WEBPACK FOOTER //
// SidebarSponsorshipComponent.vue?f103c1b0